@if (safeUrl()) {
  <iframe [src]="safeUrl()!" style="width: 100%; height: 100%; border: none; display: block;"></iframe>
}
